import { Method } from 'axios';

export interface RequestProps<D> {
  endpoint: string;
  method: Method;
  data?: D;
  params?: Record<string, unknown>;
  withCredentials?: boolean;
}

interface ErrorResponse {
  status: {
    responseStatus: 'failed';
    requestUnixTime: number;
    errorCode: 'CLIENT_CODE_MISSING';
    errorDescription: string;
  };
  data: string;
}

export interface SuccessResponse<T> {
  status: {
    responseStatus: 'ok';
    requestUnixTime: number;
    errorCode: '';
  };
  data: T;
}

interface User {
  id: number;
  username: string;
  employeeId: number;
  employeeName: string;
  groupId: number;
  isPasswordExpired: boolean;
  /** null if password expiration is not enabled for this user/account, otherwise seconds until expiration */
  passwordRemainingLifetime: number | null;
  appAccesses: Record<
    'isErplyAllowed' | 'isPOSAllowed' | 'isAppsAllowed' | 'isAPIAllowed',
    boolean
  >;
  warehouseAccesses: null | unknown;
}

type SessionKeyResponseSuccess = SuccessResponse<{
  user: User;
  sessionKey: string;
  length: number;
  createdAt: number;
  expiresAt: number;
  adminExpiresAt: number;
  isAdmin: boolean;
  services: Record<string, { url: string; documentation: string }>;
  askForPasswordRecoveryEmail: boolean;
}>;

export function isSuccessfulResponse<T>(
  response: any,
): response is SuccessResponse<T> {
  return response?.status?.responseStatus === 'ok';
}

export type SessionKeyInfoResponse = ErrorResponse | SessionKeyResponseSuccess;
